export const loading = (isLoading:boolean) => {
    return {
        type: 'SET_LOADING',
        value: isLoading
    }
}

